import React from "react";
import { AlertTriangle, ArrowRight, CheckCircle2, ChevronRight } from "lucide-react";
import { TransactionReportData } from "../../types";

interface TransactionAlertBannerProps {
  isFlagged?: boolean;
  isResolved?: boolean;
  reportData?: TransactionReportData | null;
  onReviewReport: () => void;
}

export const TransactionAlertBanner: React.FC<TransactionAlertBannerProps> = ({
  isFlagged,
  isResolved,
  reportData,
  onReviewReport,
}) => {
  // If resolved, show green banner
  if (isResolved) {
    const resolvedBy = reportData?.resolution?.resolvedBy || "Admin";
    const resolutionTime =
      reportData?.resolution?.resolutionTimeText || "recently";

    return (
      <div className="flex items-center justify-between rounded-xl border border-[#A6F4C5] bg-[#ECFDF3] px-5 py-4">
        <div className="flex items-start gap-3.5">
          <CheckCircle2
            size={22}
            className="mt-0.5 shrink-0 text-[#12B76A]"
          />
          <div className="flex flex-col gap-1">
            <span className="text-[14px] font-semibold text-[#027A48]">
              Issue resolved
            </span>
            <span className="text-[13px] text-[#027A48]">
              Customer&apos;s wallet was adjusted by {resolvedBy}
            </span>
            <span className="text-[12px] text-[#027A48]/80">
              Resolution time: {resolutionTime}
            </span>
          </div>
        </div>

        <button
          type="button"
          onClick={onReviewReport}
          className="inline-flex items-center gap-1 text-[13px] font-semibold text-[#027A48] transition-opacity hover:opacity-80"
        >
          <span>View details</span>
          <ChevronRight size={16} />
        </button>
      </div>
    );
  }

  // If flagged (and not resolved), show amber banner
  if (isFlagged) {
    const issueReason =
      reportData?.reason || "Transaction failed, but was debited";

    return (
      <div className="flex items-center justify-between rounded-xl border border-[#FEDF89] bg-[#FFFAEB] px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FEF0C7] text-[#DC6803]">
            <AlertTriangle size={15} />
          </div>
          <span className="text-[13px] font-medium text-[#101828]">
            {issueReason}
          </span>
        </div>

        <button
          type="button"
          onClick={onReviewReport}
          className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[12px] font-semibold text-[#B54708] transition-colors"
        >
          <span>Review</span>
          <ArrowRight size={14} />
        </button>
      </div>
    );
  }

  return null;
};
